import { render, staticRenderFns } from "./bouton-list.vue?vue&type=template&id=5a8fce6c&scoped=true&"
import script from "./bouton-list.vue?vue&type=script&lang=ts&"
export * from "./bouton-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8fce6c",
  null
  
)

export default component.exports